import {sorting} from "@atttomyx/shared-utils";

export const sortByYearWeek = (a, b) => {
    return sorting.sortByField(a, b, "yearWeek");
};
